import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  loadMemberData(pageno,limit,qstring){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'member-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  loadMemberLeadData(pageno,limit,qstring){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'member-leads-lists/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  uploadcsvForPlanTransaction(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-plan-transaction',data,{headers:webheader})
  }

  getPackageType()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-package-type',{headers:webheader})
  }

  getMemberWithCorporateBDs()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-bds-with-corporate-bds',{headers:webheader})
  }

  addTransactionData(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-member-transaction-data',data,{headers:webheader})
  }

  getLabtestCategory()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-lab-test-category',{headers:webheader})
  }

  getMemberBds()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-member-bds',{headers:webheader})
  }
}
